$.lui("part", ".part_item_services", function(selector) {
    selector.filter("[data-click]").on("click", function(){
        $(this).toggleClass("state--active");
    });
});